const Empty = data => {
  return Object.keys(data).length === 0;
}

export default Empty;
